import React, { useEffect, useState } from "react";
import { injectIntl } from 'react-intl';
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp, faTrash, faStar } from '@fortawesome/free-solid-svg-icons';
import * as cTypes from 'config/ConfigTypes';
import './DropdownWithInput.scss';

function DropdownWithInput(props) {
    const [current, setCurrent] = useState({});
    const [data, setData] = useState(props.data);
    const [isOpen, setIsOpen] = useState(false);
    const [ddInput, setDDInput] = useState('');

    const fm = ({ id }) => props.intl.formatMessage({ id });

    const setInitData = () => {
        setDDInput('');
        setIsOpen(false);
    }

    const onDDItemClick = (item) => {
        props.onDDClick(item);
        setTimeout(() => {
            setCurrent(item);
            setInitData();
        }, 100);
    }

    const onDDItemTrashClick = (item) => {
        props.onDDTrashClick(item);
    }

    const handleInputChange = (e) => {
        const { value } = e.target;
        setDDInput(value);
        //let newData = props.data.filter(item => item.intl.toLowerCase().includes(value))
        let newData = props.data.filter(item => {
            if (item.intl) {
                return item.intl.toLowerCase().includes(value);
            }
            return item.value.toLowerCase().includes(value);
        })
        setData(newData);
    }

    const handleOutside = ({ target }) => {
        if (!target.closest('.dropdowninput-box')) {
            setInitData();
        }
    }

    useEffect(() => {
        window.addEventListener('click', handleOutside);
        return () => {
            window.removeEventListener('click', handleOutside)
        }
    }, []);

    useEffect(() => {
        if (props.data && props.data.length > 0) {
            setData(props.data);
            if (props.current) {
                if (typeof props.current == 'string') {
                    let found = props.data.find(item => item.value === props.current
                        || item.name === props.current);
                    if (found) setCurrent(found);
                } else {
                    setCurrent(props.current);
                }
            }
            else setCurrent(props.data[0]);
        }
    }, [props.data, props.current])

    return (
        <div className="dropdowninput-box">
            <input type="text" className="dropdown-top-input" value={ddInput}
                onBlur={!props.readOnly ? () => setIsOpen(false) : null}
                onFocus={!props.readOnly ? () => setIsOpen(true) : null}
                onChange={!props.readOnly ? handleInputChange : null} />
            <div
                className={isOpen ? "dropdown active" : "dropdown"}
                onClick={() => {
                    if (data && data.length > 0 & !props.readOnly) setIsOpen(!isOpen)
                }}>
                <div className="dropdown-top">
                    <div>{(current && current.intl) ? fm({ id: current.intl }) : current.value}</div>
                    <FontAwesomeIcon icon={isOpen ? faCaretUp : faCaretDown} />
                </div>
                <CSSTransition in={isOpen} timeout={300} classNames="dropdown-animation"
                    unmountOnExit onEnter={() => setIsOpen(true)} onExited={() => setIsOpen(false)}>
                    <div className="dropdown-box">
                        <ul>
                            {data && data.map((item, i) => (
                                <li className="dropdown-li" key={`dropdownMenuItem${i}`}>
                                    <a className="data-link" onClick={onDDItemClick.bind(null, item)}>
                                        {item.intl ? fm({ id: item.intl }) : item.value}
                                    </a>
                                    {(props.isDeleted && item.value !== cTypes.XX) && (
                                        <span onClick={onDDItemTrashClick.bind(null, item)}
                                            className="dropdown-icon">
                                            <FontAwesomeIcon icon={faTrash} />
                                        </span>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                </CSSTransition>
            </div>
        </div>
    )
}

export default injectIntl(DropdownWithInput);